import 'aos/dist/aos.css'
import { lazy, Suspense, useEffect, useState } from 'react'
import About from './components/About'
import Contact from './components/Contact'
import Faq from './components/Faq'
import Footer from './components/Footer'
import Header from './components/Header'
import Hero from './components/Hero'
import Portfolio from './components/Portfolio'
import Preloader from './components/Preloader'
import Rates from './components/Rates'
import Services from './components/Services'
import SessionSelector from './components/SessionSelector'
import Tools from './components/Tools'
import Tour from './components/Tour'
const MusicPlayer = lazy(() =>
  import('./components/Portfolio/MusicPlayer').then((m) => ({
    default: m.MusicPlayer,
  }))
)

export default function App() {
  const [hasSeenProjects, setHasSeenProjects] = useState(false)

  useEffect(() => {
    try {
      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
      const hasAosElements = !!document.querySelector('[data-aos]')
      if (!prefersReducedMotion && hasAosElements) {
        import('aos')
          .then((mod) => {
            const AOS = mod.default
            AOS.init({
              duration: 500,
              easing: 'ease-in-out',
              delay: 50,
              once: true,
            })
          })
          .catch(() => {
            /* noop */
          })
      }
    } catch {
      /* empty */
    }
  }, [])

  return (
    <div id="app" className="flex min-h-screen flex-col">
      <Preloader />
      <Header />
      <main>
        <Hero />
        <Services />
        <Portfolio
          onVisible={() => {
            setHasSeenProjects(true)
          }}
          hasSeenProjects={hasSeenProjects}
        />
        <Tour />
        <Tools />
        <Rates />
        <SessionSelector />
        <About />
        <Contact />
        <Faq />
      </main>
      <Suspense fallback={<div>Loading...</div>}>
        <MusicPlayer />
      </Suspense>
      <Footer />
    </div>
  )
}
